import { isDefined } from "../../infra3d";
export var LAYERPROPERTYTYPE;
(function (LAYERPROPERTYTYPE) {
    LAYERPROPERTYTYPE[LAYERPROPERTYTYPE["STRING"] = 0] = "STRING";
    LAYERPROPERTYTYPE[LAYERPROPERTYTYPE["NUMBER"] = 1] = "NUMBER";
    LAYERPROPERTYTYPE[LAYERPROPERTYTYPE["ENUM"] = 2] = "ENUM";
    LAYERPROPERTYTYPE[LAYERPROPERTYTYPE["BOOLEAN"] = 3] = "BOOLEAN";
    LAYERPROPERTYTYPE[LAYERPROPERTYTYPE["DATE"] = 4] = "DATE";
    LAYERPROPERTYTYPE[LAYERPROPERTYTYPE["INTEGER"] = 5] = "INTEGER";
})(LAYERPROPERTYTYPE || (LAYERPROPERTYTYPE = {}));
/**
 * Property Definition.
 * @class LayerPropertyDef
 */
export class LayerPropertyDef {
    constructor(key, datatype, defautlvalue, values, propagation = false, reference_to, reference_from, name, dateformat = "Y-m-d", editable = true) {
        /**
         * Propagation of the defaultvalue. A edited property is set as defaultvalue.
         * @type {boolean}
         */
        this.propagation = false;
        this.editable = true;
        this.key = key;
        this.datatype = datatype;
        this.values = values;
        this.propagation = propagation;
        this.reference_to = reference_to;
        this.reference_from = reference_from;
        this.name = name || key;
        this.defaultvalue = isDefined(defautlvalue) ? defautlvalue : this._autoDefaultvalue();
        this.dateformat = dateformat;
        this.editable = editable;
    }
    _autoDefaultvalue() {
        switch (this.datatype) {
            case LAYERPROPERTYTYPE.INTEGER:
                return 1;
            case LAYERPROPERTYTYPE.DATE:
                return 1;
            case LAYERPROPERTYTYPE.BOOLEAN:
                return false;
            case LAYERPROPERTYTYPE.ENUM:
                return this.values[0] || "";
            case LAYERPROPERTYTYPE.STRING:
                return "";
            case LAYERPROPERTYTYPE.NUMBER:
                return 1.0;
        }
    }
    /**
     * Parses the layerdefinition (used in infra3dgeoserver) to the specified LayerPropertyDef.
     * @param ldef_propertydef
     * @returns {LayerPropertyDef}
     */
    static propertydefFromLayerdefinition(ldef_propertydef) {
        if (isDefined(ldef_propertydef.values))
            ldef_propertydef.datatype = "enum";
        let datatype;
        if (typeof ldef_propertydef.datatype == "number") {
            datatype = ldef_propertydef.datatype;
        }
        else {
            switch (ldef_propertydef.datatype) {
                case "number":
                    datatype = LAYERPROPERTYTYPE.NUMBER;
                    break;
                case "string":
                    datatype = LAYERPROPERTYTYPE.STRING;
                    break;
                case "enum":
                    datatype = LAYERPROPERTYTYPE.ENUM;
                    break;
                case "boolean":
                    datatype = LAYERPROPERTYTYPE.BOOLEAN;
                    break;
                case "date":
                    datatype = LAYERPROPERTYTYPE.DATE;
                    break;
                case "integer":
                    datatype = LAYERPROPERTYTYPE.INTEGER;
                    break;
            }
        }
        let name = ldef_propertydef.key;
        if (isDefined(ldef_propertydef.name))
            name = ldef_propertydef.name;
        return new LayerPropertyDef(ldef_propertydef.key, datatype, ldef_propertydef.defaultvalue, ldef_propertydef.values, ldef_propertydef.propagation, ldef_propertydef.reference_to, ldef_propertydef.reference_from, name, ldef_propertydef.dateformat, ldef_propertydef.editable);
    }
    /**
     * Parses the describe featuretype xsd document.
     * @param dft_node
     * @returns { any[] }
     */
    static propertydefFromLDescribeFeaturetypeNode(dft_node) {
        const options = [];
        try {
            const seq = dft_node.getElementsByTagNameNS("*", "sequence");
            const fa = seq[0].children;
            for (let j = 0; j < fa.length; j++) {
                const atb = fa[j].attributes;
                if (atb.name) {
                    if (atb.name.value !== "id" &&
                        atb.name.value !== "geometry" &&
                        atb.type.value.indexOf("gml:") !== 0) {
                        const properties = {};
                        properties["key"] = atb.name.value;
                        properties["name"] = atb.name.value;
                        properties["datatype"] = LAYERPROPERTYTYPE.STRING;
                        properties["defaultvalue"] = "";
                        const isgeom = false;
                        switch (atb.type.value) {
                            case "decimal":
                                properties["datatype"] = LAYERPROPERTYTYPE.NUMBER;
                                properties["defaultvalue"] = 0;
                                break;
                            case "string":
                                properties["datatype"] = LAYERPROPERTYTYPE.STRING;
                                properties["defaultvalue"] = "";
                                break;
                            case "int":
                                properties["datatype"] = LAYERPROPERTYTYPE.NUMBER;
                                properties["defaultvalue"] = 0;
                                break;
                        }
                        if (!isgeom)
                            options.push(properties);
                    }
                }
            }
        }
        catch (error) {
            console.warn(`could not parse describeFeatureType: ${error.message}`);
        }
        return options;
    }
}
//# sourceMappingURL=layerpropertydef.js.map